import { toast } from "react-toastify";
import { DepartmentLevel } from "models/department-level";
import DepartmentLevelFields from "Components/organisms/forms/department-level-form/types";

export const getDepartmentLevels = async (): Promise<DepartmentLevel[] | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/department-levels`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as DepartmentLevel[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting Department Levels");
        return null;
    }
}

export const submitCreateDepartmentLevelForm = async (
    vals: DepartmentLevelFields
): Promise<DepartmentLevel | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/department-levels`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(vals),
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        toast.success("Department Level created.");
        const data = await res.json();
        return data.data;
    } catch (err: any) {
        toast.error(err.message ?? "Error creating Department Level");
        return null;
    }
}

export const submitEditDepartmentLevelForm = async (
    departmentLevelId: string,
    vals: DepartmentLevelFields
): Promise<DepartmentLevel | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/department-levels/${departmentLevelId}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'PATCH',
            body: JSON.stringify(vals),
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        toast.success("Department Level updated.");
        const data = await res.json();
        return data.data;
    } catch (err: any) {
        toast.error(err.message ?? "Error editing Department Level");
        return null;
    }
}

export const deleteDepartmentLevelRequest = async (
    departmentLevelId: string
): Promise<boolean> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/department-levels/${departmentLevelId}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'DELETE',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        toast.success("Department Level deleted.");
        return true;
    } catch (err: any) {
        toast.error(err.message ?? "Error deleting Department Level");
        return false;
    }
}
